export class UtilisationWorkItem {
  constructor(
    public id: string,
    public makespan: string
  ) {}
}
